var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c("div", { staticClass: "generic--template page-template" }, [
          _c("div", { staticClass: "relative z-content pt4" }, [
            _c("div", { staticClass: "relative container-fluid mw9 center" }, [
              _c("div", { staticClass: "row relative center tl" }, [
                _c(
                  "h1",
                  {
                    staticClass:
                      "f-page-title ttu tl lh-title f2 f1-ns is-blenny is-navy",
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.page.title) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "relative" }, [
              _c(
                "div",
                { staticClass: "relative container-fluid mw9 center" },
                [
                  _c("div", {
                    staticClass: "relative mv3 cms-content",
                    domProps: {
                      innerHTML: _vm._s(_vm.marked(_vm.page.content)),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "row center" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-9 mt4 mt5-ns" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-xs-12 col-sm-8 pb5" }, [
                            _c("p", {
                              staticClass:
                                "f22px is-tablet-regular link-bold lh-copy",
                              domProps: {
                                innerHTML: _vm._s(_vm.page.intro_text),
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row" },
                          _vm._l(
                            _vm.page.content_blocks,
                            function (block, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "col-xs-12 col-sm-6 pb5",
                                },
                                [
                                  _c("h3", {
                                    staticClass: "f20px is-tablet-bold mb3",
                                    domProps: {
                                      innerHTML: _vm._s(block.title),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    staticClass:
                                      "f15px is-tablet-regular link-bold lh-copy",
                                    domProps: { innerHTML: _vm._s(block.text) },
                                  }),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.isWindowWidthMobile == true &&
          _vm.page.featured_content_section.is_published
            ? _c(
                "div",
                { staticClass: "relative bg-light-blue z-content mb5" },
                [
                  _c(
                    "section",
                    { staticClass: "relative center pv4 is-black" },
                    [
                      _c(
                        "swiper",
                        {
                          ref: "mySwiper",
                          attrs: { options: _vm.swiperOptions },
                        },
                        [
                          _c("swiper-slide", [
                            _c(
                              "div",
                              { staticClass: "relative container-fluid" },
                              [
                                _c("div", { staticClass: "db w-100" }, [
                                  _c("img", {
                                    staticClass:
                                      "db relative center img-responsive w-100",
                                    attrs: {
                                      src: _vm.page.featured_content_section
                                        .content["0"].image,
                                      alt: _vm.page.featured_content_section
                                        .content["0"].image.alt,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "f20px is-tablet-cond-bold mt4 mb3",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["0"].title
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "f15px is-tablet-regular mb3 lh-copy",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["0"].text
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "f15px is-tablet-bold",
                                      attrs: {
                                        title:
                                          _vm.page.featured_content_section
                                            .content["0"].link_title,
                                        href: _vm.page.featured_content_section
                                          .content["0"].link,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["0"].button_text
                                        )
                                      ),
                                      _c("simple-svg", {
                                        staticClass: "checkout",
                                        attrs: {
                                          filepath:
                                            "/uploads/checkout-arrow.svg",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("swiper-slide", [
                            _c(
                              "div",
                              { staticClass: "relative container-fluid" },
                              [
                                _c("div", { staticClass: "db w-100" }, [
                                  _c("img", {
                                    staticClass:
                                      "db relative center img-responsive w-100",
                                    attrs: {
                                      src: _vm.page.featured_content_section
                                        .content["1"].image,
                                      alt: _vm.page.featured_content_section
                                        .content["1"].image.alt,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "f20px is-tablet-cond-bold mt4 mb3",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["1"].title
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "f15px is-tablet-regular mb3 lh-copy",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["1"].text
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "f15px is-tablet-bold",
                                      attrs: {
                                        title:
                                          _vm.page.featured_content_section
                                            .content["1"].link_title,
                                        href: _vm.page.featured_content_section
                                          .content["1"].link,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["1"].button_text
                                        )
                                      ),
                                      _c("simple-svg", {
                                        staticClass: "checkout",
                                        attrs: {
                                          filepath:
                                            "/uploads/checkout-arrow.svg",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isWindowWidthMobile == false &&
          _vm.page.featured_content_section.is_published
            ? _c(
                "div",
                { staticClass: "relative bg-light-blue z-content mb5 mt4" },
                [
                  _c("div", { staticClass: "relative container-fluid" }, [
                    _c(
                      "section",
                      { staticClass: "relative center mw8 pt5 pb5 is-black" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-6 pr5-ns br-ns b--is-cream",
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "db relative center img-responsive w-100",
                                attrs: {
                                  src: _vm.page.featured_content_section
                                    .content["0"].image,
                                  alt: _vm.page.featured_content_section
                                    .content["0"].image.alt,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "f20px is-tablet-cond-bold mt4 mb3",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["0"].title
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "f15px is-tablet-regular mb3 lh-copy",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["0"].text
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "f15px is-tablet-bold",
                                  attrs: {
                                    title:
                                      _vm.page.featured_content_section.content[
                                        "0"
                                      ].link_title,
                                    href: _vm.page.featured_content_section
                                      .content["0"].link,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.page.featured_content_section.content[
                                        "0"
                                      ].button_text
                                    )
                                  ),
                                  _c("simple-svg", {
                                    staticClass: "checkout",
                                    attrs: {
                                      filepath: "/uploads/checkout-arrow.svg",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-6 pl5-ns pt5 pt0-m pt0-l",
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "db relative center img-responsive w-100 pt4 pt0-m pt0-l",
                                attrs: {
                                  src: _vm.page.featured_content_section
                                    .content["1"].image,
                                  alt: _vm.page.featured_content_section
                                    .content["1"].image.alt,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "f20px is-tablet-cond-bold mt4 mb3",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["1"].title
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "f15px is-tablet-regular mb3 lh-copy",
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["1"].text
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "f15px is-tablet-bold",
                                  attrs: {
                                    title:
                                      _vm.page.featured_content_section.content[
                                        "1"
                                      ].link_title,
                                    href: _vm.page.featured_content_section
                                      .content["1"].link,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.page.featured_content_section.content[
                                        "1"
                                      ].button_text
                                    )
                                  ),
                                  _c("simple-svg", {
                                    staticClass: "checkout",
                                    attrs: {
                                      filepath: "/uploads/checkout-arrow.svg",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }